"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./style.scss");

var _default = {
  name: 'Collapse',
  functional: true,
  data: function data() {
    return {};
  },
  render: function render(h, context) {
    var _context$props = context.props,
        isCollapse = _context$props.isCollapse,
        toggleCollapse = _context$props.toggleCollapse;
    return h("div", {
      "class": "collapse",
      "on": {
        "click": function click() {
          toggleCollapse(!isCollapse);
        }
      }
    }, [h("svg-icon", {
      "attrs": {
        "className": "collapse-icon",
        "iconName": isCollapse ? 'fe-menu-open' : 'fe-menu-close'
      }
    })]);
  }
};
exports.default = _default;